import httpRequest from '@/utils/fetch'

export function getMenus () {
  return httpRequest({
    url: '/admin/user/getMenu.json',
    method: 'get'
  })
}

export function getUserInfo () {
  return httpRequest({
    url: '/admin/user/get.json',
    method: 'get'
  })
}

export function getAllDeleteOaIdList () {
  return httpRequest({
    url: '/admin/account/extra/getAllDeleteOaIdList.json',
    method: 'get'
  })
}

export function deleteOaIdList (param) {
  return httpRequest({
    url: '/admin/account/extra/deleteOaIdList/delete.json?oaid=' + param,
    method: 'get'
  })
}

export function getAllCancellationMobileList () {
  return httpRequest({
    url: '/admin/account/extra/getAllCancellationMobileList.json',
    method: 'get'
  })
}

export function userCancellation (param) {
  return httpRequest({
    url: '/admin/account/extra/userCancellation.json?mobile=' + param,
    method: 'get'
  })
}

export function getLargeMarketStat (param) {
  return httpRequest({
    url: '/admin/statistics/largeMarketStat.json',
    method: 'get',
    params: param
  })
}

export function getList (param) {
  return httpRequest({
    url: '/admin/user/list.json',
    method: 'get',
    params: param
  })
}

export function punishSendAlarm (param) {
  return httpRequest({
    url: '/admin/account/punish/sendAlarm.json',
    method: 'get',
    params: param
  })
}

export function addUser (param) {
  return httpRequest({
    url: '/admin/user/add.json',
    method: 'post',
    data: param
  })
}

export function getRoleList () {
  return httpRequest({
    url: '/admin/user/getRoleList.json',
    method: 'get'
  })
}

export function updateUser (param) {
  return httpRequest({
    url: '/admin/user/update.json',
    method: 'post',
    data: param
  })
}

export function updateRole (param) {
  return httpRequest({
    url: '/admin/user/role/update.json',
    method: 'post',
    data: param
  })
}

export function getApiLog (param) {
  return httpRequest({
    url: '/admin/log/api/log.json',
    method: 'get',
    params: param
  })
}

export function getExportExcelRecord (param) {
  return httpRequest({
    url: '/admin/account/export/record/list.json',
    method: 'get',
    params: param
  })
}

export function setPermission (param) {
  return httpRequest({
    url: '/admin/user/role/setPermission.json',
    method: 'post',
    data: param
  })
}
